import React from "react";
import { Typography, Accordion, AccordionSummary, AccordionDetails, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faqs = [
  {
    q: "How do I process an invoice?",
    a: "Click 'Process Invoice' on the Dashboard and fill in the form or upload an Excel file.",
  },
  {
    q: "How do I print an invoice?",
    a: "Go to History, find the invoice, and click the 'Print' button.",
  },
  {
    q: "How do I update my API tokens?",
    a: "Go to Settings, select Sandbox or Production, enter your token, and click Save.",
  },
];

const Faqs = () => (
  <Box marginTop="25px" paddingLeft="16px" paddingRight="16px" >
    <Typography variant="h4" fontWeight={700} mb={2}  ></Typography>
    {faqs.map((faq, idx) => (
      <Accordion key={idx}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>{faq.q}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>{faq.a}</Typography>
        </AccordionDetails>
      </Accordion>
    ))}
  </Box>
);

export default Faqs;
